import { render, staticRenderFns } from "./quanTriThongBao.vue?vue&type=template&id=210c4fc8&"
import script from "./quanTriThongBao.vue?vue&type=script&lang=js&"
export * from "./quanTriThongBao.vue?vue&type=script&lang=js&"
import style0 from "./quanTriThongBao.vue?vue&type=style&index=0&lang=css&"
import style1 from "./quanTriThongBao.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports